export const externalLinks: {[key: string]: {url: string}} = {
  // 蔵衛門クラウドについて詳しく
  landing_page: {
    url: 'https://www.kuraemon.com/cloud/?from=kcloud' // TODO 準備中
  },
  // 蔵衛門Pad 製品サイト（写真一覧から遷移）
  kuraemon_pad_from_photolist: {
    url: 'https://www.kuraemon.com/pad/?from=kcloud_photolist'
  },
  // 蔵衛門Pad 製品サイト（黒板一覧から遷移）
  kuraemon_pad_from_kokubanlist: {
    url: 'https://www.kuraemon.com/pad/?from=kcloud_kokubanlist'
  },
  // 蔵衛門Pad 製品サイト（図面一覧から遷移）
  kuraemon_pad_from_zumenlist: {
    url: 'https://www.kuraemon.com/pad/?from=kcloud_drawinglist'
  },
  // 蔵衛門クラウドApp（iOS）製品サイト（写真一覧から遷移）
  kuraemon_cloud_app_from_photolist: {
    url: 'https://www.kuraemon.com/cloud/app/?from=kcloud_photolist'
  },
  // 蔵衛門クラウドApp（iOS）製品サイト（黒板一覧から遷移）
  kuraemon_cloud_app_from_kokubanlist: {
    url: 'https://www.kuraemon.com/cloud/app/?from=kcloud_kokubanlist'
  },
  // 蔵衛門クラウドApp（iOS）製品サイト（図面一覧から遷移）
  kuraemon_cloud_app_from_zumenlist: {
    url: 'https://www.kuraemon.com/cloud/app/?from=kcloud_drawinglist'
  },
  // 蔵衛門Pad Tough
  kuraemon_pad_dx_tough: {
    url: 'https://www.kuraemon.com/pad/tough/?from=kcloud_accountregister'
  },
  // 蔵衛門Pix
  kuraemon_pix: {
    url: 'https://www.kuraemon.com/pix/?from=kcloud'
  },
  // 蔵衛門Pix QRコード
  kuraemon_pix_from_qr: {
    url: 'https://www.kuraemon.com/pix/?from=qrpage'
  },
  // 蔵衛門Pix フッタ
  kuraemon_pix_from_kcloud_members: {
    url: 'https://www.kuraemon.com/pix/?from=kcloud_members'
  },
  // 蔵衛門カメラ(iOS app)
  kuraemon_camera_app_appstore: {
    url: 'https://apps.apple.com/jp/app/id6502672520'
  },
  // よくある質問
  faq: {
    url: 'https://www.kuraemon.com/support/help/?from=kcloud_web'
  },
  // 問い合わせ窓口(アカウント仮登録)
  contact: {
    url: 'https://www.kuraemon.com/contact/kcloud_free/?from=request-temporary-registration'
  },
  // 個人情報の取り扱いについて
  privacy: {
    url: 'https://www.kuraemon.com/privacy/'
  },
  // 「『プレミアム』と『フリー』の機能差はこちら」リンク
  plan_upgrading_detail: {
    url: 'https://lecre.kuraemon.com/planinfo/chart/'
  },
  // 「『プレミアム』を詳しく見る」ボタン
  plan_upgrading: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/?from=Device'
  },
  // フリー「確認」ボタン
  warning_banner_free: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/?from=account_header'
  },
  // トライアル「確認」ボタン
  warning_banner_trial: {
    url: 'https://lecre.kuraemon.com/planinfo/trial/?from=account_header'
  },
  // プレミアム「確認」ボタン
  warning_banner_premium: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/renewal/?from=account_header'
  },
  // プレミアム向け有効期限お知らせダイアログ「更新方法を確認する」ボタン
  premium_expiring_notification: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/renewal/?from=kcloud_web_renewal'
  },
  // ライセンスコード「ライセンスコードを購入する」ボタン
  purchase_license_trial: {
    url: 'https://lecre.kuraemon.com/planinfo/trial/?from=kcloudlicense'
  },
  // ライセンスコード 利用期限の更新について詳しくは「こちら」リンク
  license_updating_detail: {
    url: 'https://www.kuraemon.com/faq/?from=kcloudlicense'
  },
  // 「『プレミアム』を詳しく見る」ボタン
  plan_upgrading_construction_limit: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/?from=construction_upper'
  },
  // メンバー招待「プレミアムプラン」リンク
  member_invite_premium: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/?from=memberinvite'
  },
  // 黒板オーダーメイドフォーム
  kokuban_ordermade: {
    url: 'https://www.kuraemon.com/pad/kokuban/ordermade/?from=kcloud_web'
  },
  // 台帳オーダーメイドフォーム
  daicho_ordermade: {
    url: 'https://www.kuraemon.com/ordermade/daicho/ordermade/?from=kcloud_web'
  },
  // 蔵衛門クラウド・蔵衛門Pad 操作ガイド
  pad_guide: {
    url: 'https://www.kuraemon.com/download/dx_firstguide/overview/?from=kcloud_web'
  },
  // 蔵衛門カメラ 操作ガイド
  app_guide: {
    url: 'https://www.kuraemon.com/download/dx_ios_firstguide/overview/?from=kcloud_web'
  },
  // 問い合わせフォーム（APIでURL取得できない場合に使用する）
  contact_support_support: {
    url: 'https://www.kuraemon.com/contact_support/support/'
  },
  // 多要素認証FAQ
  mfa_support: {
    url: 'https://www.kuraemon.com/support/help/kuraemon-cloud/multi-factor-authentication/?from=kcloud_web'
  },
  // 利用期間に関して詳しくはこちら(ライセンス更新完了ダイアログ)
  license_period: {
    url: 'https://www.kuraemon.com/support/help/account/premium-license-expiry-details/?from=kcloud_web'
  },
  // 「『プレミアム』を詳しく見る」ボタン（ポスト用）
  plan_upgrading_post: {
    url: 'https://lecre.kuraemon.com/planinfo/upgrade/?from=post'
  },
}
